import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Utils } from "@/shared/utils/utils";
import store from "@/store";
import { Http } from "@status/codes";
import cloneDeep from "lodash/cloneDeep";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import {
  DASHBOARD_FIELDS,
  DASHBOARD_TEMPLATE_EVENTS,
  DASHBOARD_TEMPLATE_MESSAGES,
  INDICATOR,
  TAG
} from "../../constants/DashboardTemplatesConstants";
import { CollectionFilter } from "../../models/CollectionFilter";
import { Field } from "../../models/Field";
import { FilterItemOfQuery } from "../../models/FilterItemOfQuery";
import { FilterField } from "../../models/FilterOfCollection";
import { IndicatorOrTag } from "../../models/IndicatorOrTag";
import { Query } from "../../models/Query";
import { SectionOfDashboard } from "../../models/SectionOfDashboard";
import { ViewsConfigResponse } from "../../models/viewsConfigResponse";
import { BqDashboardService } from "../../services/BqDashboardService";
import { fixOperator, fixQuery, fixValues } from "../../Utils";
import CollectionOfSection from "../CollectionOfSection/CollectionOfSection.vue";
import DashboardFilter from "../DashboardFilter/DashboardFilter.vue";
import Indicator from "../IndicatorModal/Indicator.vue";
import TagsOfSection from "./TagsOfSection/TagsOfSection.vue";
@Component({
  name: "SectionsOfdashboard",
  components: {
    DashboardFilter,
    DynamicSelect,
    CollectionOfSection,
    Indicator,
    TagsOfSection
  },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      refreshTags: "getRefreshTags",
      refreshIndicators: "getRefreshIndicators"
      //disabledAddCollectionFilterButton: "getDisabledAddCollectionFilterButton"
    })
  }
})
export default class SectionsOfdashboard extends Vue {
  @Inject() bqDashboardService!: BqDashboardService;

  @Prop() indexSectionOfDashboard!: number;
  //@Prop() sectionOfDashboard!: SectionOfDashboard;
  @Prop() collectionsData!: ViewsConfigResponse[];
  @Prop() preloaded!: boolean;

  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  //disabledAddCollectionFilterButton!: boolean;

  refreshTags!: number;
  refreshIndicators!: number;
  addItem = GENERAL_CONSTANTS.ICONS.ADD;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  sectionName = "";
  collections: Array<CollectionFilter> = [];
  collectionsOptions: { id: string; name: string; fields: Field[] }[] = [];
  indicatorModal = false;
  optionsToIndicator: DynamicSelectData[] = [];
  storeCollectionsOptions: { id: string; name: string; fields: Field[] }[] = [];
  tagOrIndicator = "";
  tags: IndicatorOrTag[] = [];
  indicators: IndicatorOrTag[] = [];
  selectedTags = [];
  mainCollection = "";
  disabledAddCollection = false;
  elementToEdit: IndicatorOrTag = {
    indicatorOrTagName: "",
    tagOrIndicator: "",
    show: false
  };
  loading = false;
  editCase = false;
  collectionsUpdate = 0;

  mounted() {
    this.preload();
  }

  preload() {
    try {
      this.sectionName = this.currentSection.name;
      this.collections = cloneDeep(this.currentSection.collections || []);
      this.getCollectionsToMakeQuery();
      this.storeCollectionsOptions = cloneDeep(
        this.currentSection.collectionsOptions
      );
      this.collectionsOptions = (cloneDeep(
        this.collectionsData
      ) as unknown) as {
        id: string;
        name: string;
        fields: Field[];
      }[];
      this.mainCollection =
        this.currentSection.collections?.[0]?.collection?.[0]?.id || "";
      const collectionsSize = this.collections.length;
      const lastcollection = this.collections[collectionsSize - 1];

      if (
        lastcollection &&
        lastcollection.query &&
        Object.values(this.collections[collectionsSize - 1].query as Query)
          .length > 0
      ) {
        this.getOptionsToIndicator();
      }
      this.handlerIndicatorsSet(this.currentSection.indicators || []);
      this.handlerTagsSet(this.currentSection.tags || []);
      this.preloadTags(this.tags);
    } catch (error) {
      console.error("error in preload", error);
    }
  }

  preloadTags(tags: IndicatorOrTag[]) {
    for (const [, tag] of Object.entries(tags)) {
      this.editCase = true;
      this.calculateTag(tag, true);
    }
  }

  cleanElementToEdit() {
    this.elementToEdit = {
      indicatorOrTagName: "",
      tagOrIndicator: "",
      show: false
    };
  }

  @Watch("currentSection", { deep: true })
  onSectionOfDashboardChange() {
    if (
      JSON.stringify(this.tags) !== JSON.stringify(this.currentSection.tags)
    ) {
      this.verifyAndUpdateTags();
    }
    this.collections.forEach(collection => {
      const co2 = this.currentSection.collections.find(
        co => co.collection[0].id == collection.collection[0].id
      );
      if (co2?.chartType && co2.chartType != collection.chartType) {
        collection.chartType = co2?.chartType;
      }
    });
    this.sectionName = this.currentSection.name;
    this.getOptionsToIndicator();

    if (
      this.currentSection.collections.length == this.collections.length ||
      this.currentSection.collections.length < this.collections.length
    ) {
      return;
    }

    const collectionsCopy = cloneDeep(this.currentSection.collections);
    this.collections.push(collectionsCopy[collectionsCopy.length - 1]);
    this.collectionsOptions = this.currentSection.collectionsOptions || [];
    this.mainCollection =
      this.currentSection.collections?.[0]?.collection?.[0]?.id || "";
  }

  get currentSection() {
    return this.sectionsOfDashboardStore[this.indexSectionOfDashboard];
  }

  get addTagButton() {
    const collections = this.currentSection.collections.map(
      item => item.collection[0].name
    );
    return !collections.some(c => c);
  }

  @Watch("sectionsOfDashboardStore", { deep: true })
  canAddCollectionFilter() {
    const lastCollection = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections[
      this.sectionsOfDashboardStore[this.indexSectionOfDashboard].collections
        .length - 1
    ];
    if (!lastCollection.collection[0].name) {
      this.disabledAddCollection = true;
      return;
    }

    if (lastCollection.filters.length == 0) {
      this.disabledAddCollection = false;
      return;
    }

    for (const filter of lastCollection.filters) {
      if (filter.field.length == 0) {
        this.disabledAddCollection = true;
        return;
      }
      if (filter.operator.length == 0) {
        this.disabledAddCollection = true;
        return;
      }
      if (filter.value.length == 0) {
        this.disabledAddCollection = true;
        return;
      }
    }

    this.disabledAddCollection = false;
  }

  deleteCollection(collection: DynamicSelectData) {
    this.collectionsUpdate = this.collectionsUpdate + 1;
    this.collections = cloneDeep(this.currentSection.collections);
    this.deleteTagsWhenCollectionIsDeleted(collection);
  }
  deleteTagsWhenCollectionIsDeleted(collection: DynamicSelectData) {
    const tagsToDelete = this.tags.filter(
      tag => tag.query?.principalView == collection.id
    );
    tagsToDelete.forEach(tag => {
      this.handlerTagEvent(
        DASHBOARD_TEMPLATE_EVENTS.DELETE_TAG,
        tag,
        this.tags.findIndex(t => t.indicatorOrTagName == tag.indicatorOrTagName)
      );
    });
  }

  buildTags(tags: IndicatorOrTag[]): IndicatorOrTag[] {
    return cloneDeep(
      tags.map(tag => {
        let fieldToOperate = tag.fieldToOperate as any;
        const selectorFieldToOperate = tag.selectorFieldToOperate as any;
        if (!fieldToOperate) {
          if (tag.field == DASHBOARD_FIELDS.DOC_ID) {
            fieldToOperate = [
              {
                id: DASHBOARD_FIELDS.DOC_ID,
                name: DASHBOARD_FIELDS.DOC_ID,
                collection: { id: tag.view }
              }
            ];
          } else {
            fieldToOperate = [
              {
                id: tag.field,
                name: (tag as any).fieldName || tag.field,
                collection: { id: tag.view }
              }
            ];
          }
        }
        return { ...tag, fieldToOperate, selectorFieldToOperate };
      }) || []
    );
  }

  @Watch("refreshTags")
  verifyAndUpdateTags() {
    console.log("this.preloaded", this.preloaded);
    if (!this.preloaded) return;
    console.log("verifyAndUpdateTags");
    this.tags = this.buildTags(
      this.sectionsOfDashboardStore[this.indexSectionOfDashboard].tags
    );
    this.verifyAndUpdateIndicators();
  }

  @Watch("refreshIndicators")
  verifyAndUpdateIndicators() {
    this.indicators = cloneDeep(this.currentSection.indicators || []);
    this.indicators.forEach(indicator => {
      this.calculateIndicator(indicator);
    });
  }
  getOptionsToIndicator() {
    this.optionsToIndicator = [];
    const collections = this.currentSection.collections.map(
      item => item.collection[0].name
    );

    const collectionsOptions = this.currentSection.collectionsOptions.filter(
      collectionOptions => {
        return collections.includes(collectionOptions.name);
      }
    );
    collectionsOptions.forEach(collection => {
      collection.fields.forEach(field => {
        this.optionsToIndicator.push({
          id: field.field,
          name: field.visualField,
          type: field.type,
          list: field.list,
          operators: field.operators,
          collection: { id: collection.id, name: collection.name },
          formTemplate: field.formTemplate
        });
      });
    });
  }

  addCollectionFilter() {
    store.commit(
      DASHBOARD_TEMPLATE_EVENTS.ADD_COLLECTION_TO_SECTION_OF_DASHBOARD,
      {
        index: this.indexSectionOfDashboard,
        collection: {
          collection: [{ id: "", name: "" }],
          filters: [],
          id: Utils.idGenerator()
        }
      }
    );
  }

  @Watch("sectionName")
  onSectionNameChange() {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.UPDATE_SECTION_NAME_OF_DASHBOARD, {
      index: this.indexSectionOfDashboard,
      name: this.sectionName
    });
  }

  deleteSectionOfDashboard() {
    if (this.sectionsOfDashboardStore.length === 1) {
      Snackbar.popWarning("Debe tener al menos una sección");
      return;
    }
    this.$emit("deleteSectionOfDashboard", this.indexSectionOfDashboard);
  }

  getCollectionsToMakeQuery() {
    store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_COLLECTIONS_OPTIONS, {
      index: this.indexSectionOfDashboard,
      collectionsOptions: cloneDeep(this.collectionsData)
    });
  }

  addIndicator(element: string) {
    this.cleanElementToEdit();
    this.tagOrIndicator = element;
    this.indicatorModal = true;
  }

  async closeIndicatorModal(event: IndicatorOrTag) {
    this.indicatorModal = false;
    if (!event) {
      this.cleanTagOrIndicatatorToEdit();
      return;
    }
    if (this.verifyIfItemChange(this.elementToEdit, event)) {
      this.cleanTagOrIndicatatorToEdit();
      return;
    }
    if (event.tagOrIndicator === INDICATOR) {
      this.calculateIndicator(event);
      this.cleanTagOrIndicatatorToEdit();
      return;
    }

    if (
      event.tagOrIndicator === TAG &&
      event.operation &&
      event.fieldToOperate
    ) {
      if (this.elementToEdit.indicatorOrTagName != event.indicatorOrTagName) {
        const indicators = this.indicators.map(i => {
          const formulaToCreateIndicator = i.formulaToCreateIndicator?.map(
            f => {
              const id = Array.isArray(f) ? f[0]?.id : f.id;
              return id == this.elementToEdit.indicatorOrTagName
                ? [
                    {
                      id: event.indicatorOrTagName,
                      name: event.indicatorOrTagName
                    }
                  ]
                : f;
            }
          );
          return { ...i, formulaToCreateIndicator };
        });
        this.handlerIndicatorsSet(indicators);
      }

      await this.calculateTag(event);

      this.cleanTagOrIndicatatorToEdit();
    }
  }

  calculateIndicator(event: IndicatorOrTag) {
    let formula = "";

    event.formulaToCreateIndicator!.forEach((item, index) => {
      const idItem = Array.isArray(item) ? item[0]["id"] : item.id;
      if (index == 1) {
        formula = formula + idItem;
      } else {
        const tag = this.tags.find(tag => tag.indicatorOrTagName == idItem);
        if (tag) {
          formula = formula + tag.value!.toString();
        }
      }
    });

    event.value = eval(formula).toFixed(2);

    let index = 0;
    if (this.elementToEdit.tagOrIndicator == INDICATOR) {
      index = this.indicators.findIndex(
        indicator =>
          indicator.indicatorOrTagName == this.elementToEdit.indicatorOrTagName
      );
    } else {
      index = this.indicators.findIndex(
        indicator => indicator.indicatorOrTagName == event.indicatorOrTagName
      );
    }
    const action =
      index < 0
        ? DASHBOARD_TEMPLATE_EVENTS.ADD_INDICATOR
        : DASHBOARD_TEMPLATE_EVENTS.UPDATE_INDICATOR;

    this.handlerIndicatorEvent(action, event, index);
  }

  handlerIndicatorEvent(
    event: string,
    indicator: IndicatorOrTag,
    index: number
  ) {
    switch (event) {
      case DASHBOARD_TEMPLATE_EVENTS.ADD_INDICATOR:
        //this.indicators.push(indicator);
        break;

      case DASHBOARD_TEMPLATE_EVENTS.UPDATE_INDICATOR:
        if (index !== -1) {
          this.indicators[index] = indicator;
        }
        break;

      case DASHBOARD_TEMPLATE_EVENTS.DELETE_INDICATOR:
        if (index !== -1) {
          //this.indicators.splice(index, 1);
        }
        break;

      default:
        console.error("NOT HANDLER EVENT", event);
        return;
    }

    this.$store.commit(event, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      index,
      indicator: cloneDeep(indicator)
    });
  }
  handlerIndicatorsSet(indicators: IndicatorOrTag[]) {
    this.$store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_INDICATORS, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      indicators: cloneDeep(indicators)
    });
    this.indicators = indicators;
  }

  handlerTagEvent(event: string, tag: IndicatorOrTag, index: number) {
    switch (event) {
      case DASHBOARD_TEMPLATE_EVENTS.ADD_TAG:
        break;
      case DASHBOARD_TEMPLATE_EVENTS.UPDATE_TAG:
        this.tags[index] = tag;
        break;
      case DASHBOARD_TEMPLATE_EVENTS.DELETE_TAG:
        this.deleteIndicatorWhenTagIsDeleted(tag);
        break;
      default:
        console.error("NOT HANDLER EVENT", event);
        return;
    }
    console.log("handlerTagEvent", event, tag, index);
    this.$store.commit(event, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      index,
      tag: cloneDeep(tag)
    });
  }

  deleteIndicatorWhenTagIsDeleted(tag: IndicatorOrTag) {
    this.indicators.forEach(indicator => {
      indicator.formulaToCreateIndicator!.forEach(item => {
        const itemId = Array.isArray(item) ? item[0]["id"] : item.id;
        if (itemId == tag.indicatorOrTagName) {
          this.handlerIndicatorEvent(
            DASHBOARD_TEMPLATE_EVENTS.DELETE_INDICATOR,
            indicator,
            this.indicators.findIndex(
              i => i.indicatorOrTagName == indicator.indicatorOrTagName
            )
          );
        }
      });
    });
  }

  handlerTagsSet(tags: IndicatorOrTag[]) {
    this.$store.commit(DASHBOARD_TEMPLATE_EVENTS.SET_TAGS, {
      indexSectionOfDashboard: this.indexSectionOfDashboard,
      tags: cloneDeep(tags)
    });
    this.tags = cloneDeep(tags);
  }
  private getFilters(
    collections: CollectionFilter[]
  ): FilterItemOfQuery[] | undefined {
    const filters: FilterItemOfQuery[] = [];

    for (const [indexCollection, collection] of collections.entries()) {
      if (collection.filters.length === 0) {
        filters.push({
          view: collection.collection[0].id,
          field: "",
          operator: "",
          value: []
        });
        continue;
      }
      for (const filter of collection.filters) {
        if (!(filter.field[0] as FilterField)) return;
        filters.push({
          view: collection.collection[0].id,
          field: (filter.field[0] as FilterField).id,
          operator: fixOperator(filter.operator as DynamicSelectData[]) || "",
          value: fixValues(
            filter,
            indexCollection,
            this.sectionsOfDashboardStore,
            this.indexSectionOfDashboard
          )
        });
      }
    }
    return filters;
  }

  private buildQueryTag(
    tag: IndicatorOrTag,
    preload: boolean
  ): Query | undefined {
    let lastCollectionQuery: Query = {
      selectFields: {
        fields: [],
        agregations: []
      },
      principalView: "",
      filters: [],
      groupFields: []
    };

    if (preload) {
      lastCollectionQuery = tag.query as Query;
    } else {
      const collections = this.sectionsOfDashboardStore[
        this.indexSectionOfDashboard
      ].collections;

      const filters = this.getFilters(collections);
      if (filters === undefined) return;

      const newFilters = filters.map((e: FilterItemOfQuery) => {
        if (
          e.view === "forms" &&
          e.field === "formTemplate" &&
          Array.isArray(tag.selectorFieldToOperate) &&
          tag.selectorFieldToOperate.length > 0
        ) {
          const value = e.value as any[];
          const newValue =
            Array.isArray(value) && value.length > 0
              ? value.filter(
                  (e: any) => e == tag.fieldToOperate![0].formTemplate
                )
              : value;
          return {
            ...e,
            value: newValue
          };
        }
        return e;
      });
      lastCollectionQuery.filters = newFilters as FilterItemOfQuery[];

      const selectorToOperate =
        tag.selectorFieldToOperate && tag.selectorFieldToOperate.length > 0
          ? tag.selectorFieldToOperate[0].id
          : "";
      lastCollectionQuery.selectFields.agregations.push({
        type: (tag.operation as { id: string; name: string }[])![0].id,
        view: tag.fieldToOperate![0].collection!.id,
        field: tag.fieldToOperate![0].id,
        alias: selectorToOperate
          ? selectorToOperate
          : tag.fieldToOperate![0].id,
        selector: selectorToOperate
      });
      lastCollectionQuery!.groupFields = [];
      lastCollectionQuery.principalView = tag.fieldToOperate![0].collection!.id;
    }

    return lastCollectionQuery;
  }

  async calculateTag(tag: IndicatorOrTag, preload = false) {
    console.log("calculateTag", tag, preload);
    const lastCollectionQuery = this.buildQueryTag(tag, preload);
    if (lastCollectionQuery === null) return;
    console.log("lastCollectionQuery", lastCollectionQuery);
    const allFiltersOfSection = this.sectionsOfDashboardStore[
      this.indexSectionOfDashboard
    ].collections.flatMap(collection => collection.filters);

    const queryFixed = fixQuery(
      lastCollectionQuery as Query,
      allFiltersOfSection as FilterItemOfQuery[]
    );

    this.loading = true;
    const dataToChartResponse = await this.bqDashboardService.getDataToChart(
      queryFixed
    );

    if (dataToChartResponse.code == Http.Found) {
      console.log("response ok");
      this.loading = false;
      dataToChartResponse.data.result[0].docId;
      const rawValue = Object.values(dataToChartResponse.data.result[0])[0];
      const numericValue = Number(rawValue);
      tag.value = Number.isFinite(numericValue)
        ? Number(numericValue.toFixed(2))
        : 0;
      tag.query = lastCollectionQuery;
      if (this.elementToEdit.indicatorOrTagName) {
        this.updateTag(tag);
        return;
      }
      console.log("preload", preload);
      if (preload) {
        const index = this.tags.findIndex(
          tagIndex => tagIndex.indicatorOrTagName == tag.indicatorOrTagName
        );
        this.handlerTagEvent(DASHBOARD_TEMPLATE_EVENTS.UPDATE_TAG, tag, index);
        return;
      }
    }
    this.handlerTagEvent(DASHBOARD_TEMPLATE_EVENTS.ADD_TAG, tag, 0);
    this.loading = false;
  }

  updateTag(event: IndicatorOrTag) {
    const index = this.tags.findIndex(
      tag => tag.indicatorOrTagName == this.elementToEdit.indicatorOrTagName
    );
    this.handlerTagEvent(DASHBOARD_TEMPLATE_EVENTS.UPDATE_TAG, event, index);
  }

  editIndicator(index: number) {
    this.tagOrIndicator = INDICATOR;
    this.elementToEdit = this.indicators[index];
    this.indicatorModal = true;
  }

  editTag(index: number) {
    this.tagOrIndicator = TAG;
    this.elementToEdit = this.tags[index];
    this.indicatorModal = true;
  }

  deleteTag(index: number) {
    const tag = this.tags[index];
    for (const indicator of this.indicators) {
      for (const item of indicator.formulaToCreateIndicator!) {
        const idItem = Array.isArray(item) ? item[0]["id"] : item.id;

        if (idItem == tag.indicatorOrTagName) {
          Snackbar.popError(DASHBOARD_TEMPLATE_MESSAGES.TAG_IN_USE);
          return;
        }
      }
    }

    this.handlerTagEvent(
      DASHBOARD_TEMPLATE_EVENTS.DELETE_TAG,
      this.tags[index],
      index
    );
  }

  toggleTag(index: number) {
    const tag = this.tags[index];
    this.handlerTagEvent(
      DASHBOARD_TEMPLATE_EVENTS.UPDATE_TAG,
      { ...tag, show: !tag.show },
      index
    );
  }

  toggleIndicator(index: number) {
    const indicator = this.indicators[index];
    this.handlerIndicatorEvent(
      DASHBOARD_TEMPLATE_EVENTS.UPDATE_INDICATOR,
      { ...indicator, show: !indicator.show },
      index
    );
  }

  deleteIndicator(index: number) {
    this.handlerIndicatorEvent(
      DASHBOARD_TEMPLATE_EVENTS.DELETE_INDICATOR,
      this.indicators[index],
      index
    );
  }

  cleanTagOrIndicatatorToEdit() {
    this.elementToEdit = {
      indicatorOrTagName: "",
      tagOrIndicator: "",
      show: false
    };
  }

  verifyIfItemChange(tagToEdit: IndicatorOrTag, event: IndicatorOrTag) {
    const cloneTagToEdit = cloneDeep(tagToEdit);
    delete cloneTagToEdit.value;
    return JSON.stringify(cloneTagToEdit) === JSON.stringify(event);
  }

  onCollectionFieldChange() {
    this.collectionsUpdate = this.collectionsUpdate + 1;
  }

  handleShowLoadingBar(event: boolean) {
    this.loading = event;
  }
}
